export const DECISION_TREE_LAYER_WIDTH = {
	LAYER_A: 'large',
	LAYER_B: 'large',
	LAYER_C: 'fullWidth',
	LAYER_D: 'large',
	LAYER_E: 'large',
	LAYER_F: 'fullWidth',
	LAYER_G: 'fullWidth'
}
